import { render, staticRenderFns } from "./pkqRule.vue?vue&type=template&id=5a47f9a3&scoped=true"
import script from "./pkqRule.vue?vue&type=script&lang=js"
export * from "./pkqRule.vue?vue&type=script&lang=js"
import style0 from "./pkqRule.vue?vue&type=style&index=0&id=5a47f9a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47f9a3",
  null
  
)

export default component.exports